<template>
  <div class="house-importer-import-charges-stage-edit-devices-panel" ref="container">
    <app-panel title="Приборы учета и показания">

      <div slot="actions" class="house-importer-import-charges-stage-edit-devices-panel__actions">
        <div class="house-importer-import-charges-stage-edit-devices-panel__actions-col">
          <app-input label="Лицевой счет" v-model="accountNumber" />
        </div>

        <div class="house-importer-import-charges-stage-edit-devices-panel__actions-col">
          <app-select label="Тип прибора" v-model="deviceType">
            <vs-select-item
              :key="deviceType.id" :value="deviceType.id"
              :text="deviceType.name"
              v-for="deviceType in devicesTypes"
            />
          </app-select>
        </div>

        <div class="house-importer-import-charges-stage-edit-devices-panel__actions-col">
          <app-button color="success" @click="getDevices">Показать</app-button>
        </div>
        <div class="house-importer-import-charges-stage-edit-devices-panel__actions-col" v-if="showUpdateStatusButton">
          <app-button color="success" :disabled="isUpdating" @click="updateDevicesStatus">
            {{ isUpdating ? 'Обновляюстатусы...' : 'Обновить статусы' }}
          </app-button>
        </div>
        <div class="house-importer-import-charges-stage-edit-devices-panel__actions-col">
          <app-button color="success" @click="openCheckDeviceCount">Проверить кол-во</app-button>
        </div>
      </div>

      <div
        class="house-importer-import-charges-stage-edit-devices-panel__error-block"
        v-if="status === STATUSES.error"
      >
        {{ textError }}
      </div>
      <div class="house-importer-import-charges-stage-edit-devices-panel" v-if="status === STATUSES.loaded">
        <vs-tabs>
          <vs-tab
            :label="`Прибор ${index+1}`" v-for="(device, index) in devices" :key="`device-type-${index}`"
            :ref="`tabsTab-${device.id}`"
          >

            <div class="house-importer-import-charges-stage-edit-devices-panel__content">
              <div class="house-importer-import-charges-stage-edit-devices-panel__device-info">
                <div class="house-importer-import-charges-stage-edit-devices-panel__device-info-row">
                  <app-input label="Лицевой счет" :value="device.account_number" readonly />
                </div>
                <div class="house-importer-import-charges-stage-edit-devices-panel__device-info-row">
                  <app-input label="Имя прибора" :value="device.device_name" readonly />
                </div>
                <div class="house-importer-import-charges-stage-edit-devices-panel__device-info-row">
                  <app-input label="Заводской номер" :value="device.factory_number" readonly />
                </div>
                <div class="house-importer-import-charges-stage-edit-devices-panel__device-info-row">
                  <app-input label="Начальное показание" :value="device.start_value" readonly />
                </div>
                <div class="house-importer-import-charges-stage-edit-devices-panel__device-info-row">
                  <app-datepicker label="Дата начала эксплуатации" v-model="device.operation_start_date" />
                </div>
                <div class="house-importer-import-charges-stage-edit-devices-panel__device-info-row">
                  <app-datepicker label="Дата следующей поверки" v-model="device.next_checking_date" />
                </div>
                <div class="house-importer-import-charges-stage-edit-devices-panel__device-info-row">
                  <app-input label="Deleted" :value="device.deleted_at" readonly />
                </div>
                <div class="house-importer-import-charges-stage-edit-devices-panel__device-info-row">
                  <vs-checkbox v-model="device.inactive">Inactive</vs-checkbox>
                </div>
                <div class="house-importer-import-charges-stage-edit-devices-panel__device-info-row">
                  <vs-checkbox v-model="device.resetDeletedAt">Восстановить прибор</vs-checkbox>
                </div>
                <div class="house-importer-import-charges-stage-edit-devices-panel__device-info-row house-importer-import-charges-stage-edit-devices-panel__device-info-row_buttons">
                  <app-button color="danger" style="margin-right: 5px" @click="deleteDevice(device)">Удалить
                  </app-button>
                  <app-button color="success" @click="saveDevice(device)">Сохранить</app-button>
                </div>
              </div>
              <div class="house-importer-import-charges-stage-edit-devices-panel__device-values">
                <vs-table
                  :data="device.values" hoverFlat
                  class="house-importer-import-charges-stage-edit-devices-panel__table"
                  no-data-text="Показаний нет нет"
                >
                  <template slot="thead">
                    <vs-th>Месяц</vs-th>
                    <vs-th>Значение</vs-th>
                    <vs-th>is_standard</vs-th>
                    <vs-th>calculated</vs-th>
                    <vs-th width="170px">
                      <app-button size="small" class="link-icon" @click="openAddValue(device)">
                        Добавить новое
                      </app-button>
                    </vs-th>
                  </template>
                  <template slot-scope="{data}">
                    <vs-tr :key="`${trIndex}`" v-for="(tr, trIndex) in data">
                      <vs-td>{{ $parseDateFromString(tr.date_value) | moment('MMMM YYYY') }}</vs-td>
                      <vs-td>
                        <app-input v-model="tr.value" vtype="udouble" @input="tr.status = VALUES_STATUSES.edit" />
                      </vs-td>
                      <vs-td>
                        <vs-checkbox v-model="tr.is_standard" @input="tr.status = VALUES_STATUSES.edit" />
                      </vs-td>
                      <vs-td>
                        <vs-checkbox v-model="tr.calculated" @input="tr.status = VALUES_STATUSES.edit" />
                      </vs-td>
                      <vs-td>
                        <div v-if="tr.status === VALUES_STATUSES.edit">
                          <app-button size="small" @click="saveValue(tr)" color="success">
                            Сохранить
                          </app-button>
                        </div>
                        <div v-if="tr.status === VALUES_STATUSES.sending">
                          <div>Сохраняю...</div>
                        </div>
                        <div v-if="tr.status === VALUES_STATUSES.saved">
                          <div style="color: rgba(var(--app-success), 1)">Сохранено</div>
                        </div>
                        <div v-if="tr.status === VALUES_STATUSES.added">
                          <div style="color: rgba(var(--app-success), 1)">Добавлено</div>
                        </div>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
      <div
        class="house-importer-import-charges-stage-edit-devices-panel__loading-block"
        v-if="status === STATUSES.loading"
      >
        <div class="block-loading" />
        <div>Получаю данные...</div>
      </div>
    </app-panel>
    <AddNewValuePopup ref="addValuePopup" @add="addDeviceValue" />
    <CheckAmountDevicesPopup ref="devicesAmountPopup" :import-info="importInfo" />
  </div>
</template>

<script>
import * as deviceTypes        from "@/client/dictionaries/deviceTypes";
import AddNewValuePopup        from "../components/AddNewValuePopup";
import CheckAmountDevicesPopup from "../../import-finished-stage/popups/CheckAmountDevicesPopup";

const STATUSES = {
  mounted: 0,
  loading: 1,
  loaded:  2,
  error:   3,
};

const VALUES_STATUSES = {
  default: 0,
  edit:    1,
  sending: 2,
  saved:   3,
  added:   4,
};


export default {
  name:       "EditDevices",
  components: {
    AddNewValuePopup,
    CheckAmountDevicesPopup,
  },
  props:      {
    importInfo:             {},
    showUpdateStatusButton: {
      type:    Boolean,
      default: false,
    },
  },
  data() {
    return {
      STATUSES:        STATUSES,
      VALUES_STATUSES: VALUES_STATUSES,
      status:          STATUSES.mounted,
      deviceType:      0,
      accountNumber:   null,
      devices:         [],
      devicesTypes:    [],
      isUpdating:      false,
    };
  },
  computed:   {},
  methods:    {
    openCheckDeviceCount() {
      this.$refs.devicesAmountPopup.open();
    },
    deleteDevice( device ) {
      this.$vs.dialog({
        type:       'confirm',
        color:      'danger',
        title:      'Подтверждение',
        text:       'Удалить прибор?',
        acceptText: 'Да',
        cancelText: 'Отменить',
        accept:     async () => {
          try {
            await this.$http.delete('import/houses/devices', {
              params: {
                id: device.id,
              },
            });
            this.$vs.notify({ color: 'success', title: 'Удалено', text: 'Прибор удален' });
            this.getDevices();
          } catch (e) {
            this.$vs.notify({ color: 'danger', title: 'ERROR', text: e.message });
          }
        },
      });
    },
    async updateDevicesStatus() {
      this.isUpdating = true;
      try {
        let { data } = await this.$http.get('import/houses/actualize_devices_state', { params: { import_id: this.importInfo.id } });

        if (data === 'done') {
          this.$vs.notify({ color: 'success', title: 'Успешное обновления', text: 'Статусы обновлены' });
        } else {
          this.$vs.notify({ color: 'danger', title: 'UNKNOWN ANSWER', text: data });
        }
      } catch (e) {
        this.$vs.notify({ color: 'danger', title: 'ERROR', text: e.message });
      } finally {
        setTimeout(() => {
          this.isUpdating = false;
        }, 300);
      }
    },
    openAddValue( device ) {
      this.$refs.addValuePopup.open(device);
    },
    addDeviceValue( { device, value } ) {
      let index = this.devices.findIndex(d => d.id === device.id);
      value.status = VALUES_STATUSES.added;
      this.devices[index].values.push(value);
    },
    getDevicesByAccountNumber( accountNumber ) {
      this.accountNumber = accountNumber;
      this.getDevices();
    },
    async getDevices() {
      this.status = STATUSES.loading;
      this.$refs.container.scrollIntoView({ block: "start", behavior: "smooth" });
      try {
        let { data } = await this.$http.get('import/houses/devices', {
          params: {
            import_id:      this.importInfo.id,
            account_number: this.accountNumber,
            type:           this.deviceType,
          },
        });
        let devices = data.map(device => {
          device.resetDeletedAt = false;
          device.values = device.values.map(v => {
            v.status = VALUES_STATUSES.default;
            return v;
          });
          return device;
        });

        this.devices = devices;
        setTimeout(() => {
          this.status = STATUSES.loaded;
        }, 300);
      } catch (e) {
        if (e.response) {
          if (e.response.status === 404) {
            this.status = STATUSES.error;
            this.textError = "Приборы не найдены";
          }
        } else {
          this.$vs.notify({ color: 'danger', title: 'ERROR', text: e.message });
          this.status = STATUSES.mounted;
        }
      } finally {
        setTimeout(() => {
          this.$nextTick(() => {
            this.$refs.container.scrollIntoView({ block: "start", behavior: "smooth" });
          });
        }, 300);
      }
    },
    async saveDevice( device ) {
      try {
        let body = {
          id:                   device.id,
          operation_start_date: device.operation_start_date ? this.$options.filters.moment(device.operation_start_date, 'YYYY-MM-DD') : null,
          next_checking_date:   device.next_checking_date ? this.$options.filters.moment(device.next_checking_date, 'YYYY-MM-DD') : null,
          inactive:             device.inactive,
          deleted_at:           device.resetDeletedAt ? null : device.deleted_at,
        };

        await this.$http.put('import/houses/devices', body);
        this.$vs.notify({ color: 'success', title: 'Успешное изменение', text: 'Прибор изменен' });

      } catch (e) {
        this.$vs.notify({ color: 'danger', title: 'ERROR', text: e.message });
      }
    },
    async saveValue( value ) {
      value.status = VALUES_STATUSES.sending;
      let body = {
        id:          value.id,
        value:       value.value,
        calculated:  value.calculated,
        is_standard: value.is_standard,
      };
      try {
        await this.$http.put('import/houses/device_value', body);
        value.status = VALUES_STATUSES.saved;
        this.$vs.notify({ color: 'success', title: 'Успешное изменение', text: 'Показание изменено' });
      } catch (e) {
        this.$vs.notify({ color: 'danger', title: 'ERROR', text: e.message });
        value.status = VALUES_STATUSES.edit;
      }
    },
  },
  mounted() {
    deviceTypes.getList().then(( list ) => {
      this.devicesTypes = list;
    });
  },
};
</script>

<style lang="scss">
.house-importer-import-charges-stage-edit-devices-panel {

  &__loading-block {
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .block-loading {
      width: 60px;
      height: 60px;
      flex: 0;
      margin-bottom: 20px;
    }
  }

  &__error-block {
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-weight: 500;
    text-align: center;
    font-size: 18px;
  }

  .con-vs-checkbox {
    margin: 0;
    margin-right: 15px;

    .con-slot-label {
      line-height: 1.1;
      color: #627084;
      font-size: 14px;
    }
  }

  &__actions {
    display: flex;
    align-items: flex-end;
    margin: 0 -7.5px;

    &-col {
      padding: 0 7.5px;
    }
  }

  &__device-info {
    min-width: 380px;
    max-width: 380px;
    flex: 1;
    padding: 0 7.5px;

    &-row {
      margin-bottom: 15px;

      &_buttons {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  &__device-values {
    flex: 1;
    padding: 0 7.5px;
  }

  &__table {
    .vs-table--tbody {
      border: none;
      background: #fff;
    }

    .vs-table--thead th {
      padding: 0 !important;
      border-bottom: 1px solid rgba(0, 0, 0, .125);

      .vs-table-text {
        text-align: left;
        position: relative;
        vertical-align: bottom;
        padding: .75rem 10px;
        background: transparent;
        font-size: 12px;
      }
    }

    .vs-table {
      .vs-table--tr:nth-child(2n+1) {
        background: #f5f8fa;
      }
    }

    .tr-values td {
      padding: .5rem 10px;
      font-size: 12px;
    }

    .vs-table--pagination {
      justify-content: center;
    }

    .app-button {
      padding: 0 10px !important;
    }

    .app-button__text {
      color: #fff !important;
      font-weight: 400 !important;
      font-size: 12px !important;
    }
  }

  &__content {
    display: flex;
    padding-top: 20px;
    margin: 0 -7.5px;
  }
}

.vs-tabs-primary .activeChild button, .vs-tabs-primary button.app-button:not(:disabled):hover {
  color: #fff !important;
}
</style>
